import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// formik
import { Formik } from 'formik';
import * as Yup from 'yup';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import withStyles from '@material-ui/core/styles/withStyles';
import extendedTablesStyle from 'assets/jss/material-dashboard-pro-react/views/extendedTablesStyle';
import customSelectStyle from 'assets/jss/material-dashboard-pro-react/customSelectStyle';
import GridContainer from 'components/UI/Grid/GridContainer';
import WithPermission from 'components/User/WithPermission';
import GridItem from 'components/UI/Grid/GridItem';
import Button from 'components/UI/CustomButtons/Button';
import sweetAlertStyle from 'assets/jss/material-dashboard-pro-react/views/sweetAlertStyle';
import Snackbars from 'components/UI/Snackbar/Snackbar';

const EMAIL_TEMPLATES = [
  'ad_contacted',
  'ad_contacted_email_disabled_error',
  'ad_contacted_notfound_error',
  'ad_contacted_undelivered_error',
  'ad_contacted_unpublished_error',
  'agency_low_credit',
  'credit_added',
  'noti_ad_price_reduced',
  'noti_favorite_profile_published',
  'noti_favorite_profile_published_multiple',
  'noti_new_follower',
  'paid_ad_close_end',
  'paid_ad_end',
  'paid_ad_end_agency',
  'paid_ad_start',
  'payment_success',
  'send_handling_links',
  'social_reset_password',
  'verify_code',
];

const translateValidationSchema = t =>
  Yup.object({
    context: Yup.string().required(t('errors.required')),
    template: Yup.string().required(t('errors.required')),
    email: Yup.string().required(t('errors.required')),
  });

/**
 * Initial values to AdForm
 */
const initialValues = {
  context: '',
  template: '',
  email: '',
};
class SendEmail extends React.Component {
  constructor(props) {
    super(props);
    this.formikRef = null;
    this.state = {
      fields: {
        ...initialValues,
      },
    };
  }

  setServerErrors = serverErrors => {
    let all = null;
    if (this.formikRef && serverErrors.length) {
      const errors = {};

      serverErrors.forEach(item => {
        errors[item.field] = item.messages;
        if (item.field === '__all__') {
          all = item.messages;
        }
      });

      setTimeout(() => this.formikRef && this.formikRef.setErrors(errors), 0);
    }
    return all;
  };

  render() {
    const { fields } = this.state;

    const {
      classes,
      t,
      sendEmail,
      errors: serverErrors,
      success,
      closeNotification,
    } = this.props;
    const all = this.setServerErrors(serverErrors);
    const validationSchema = translateValidationSchema(t);
    return (
      <React.Fragment>
        <Snackbars
          place="tc"
          message={all || ''}
          open={!!all}
          color="danger"
          closeNotification={() => closeNotification()}
          close
        />
        <Snackbars
          place="tc"
          message={t('send_email.success')}
          open={success}
          color="success"
          closeNotification={() => closeNotification()}
          close
        />
        <div className={classes.pageContainer}>
          <h3 className={classes.title}>{t('send_email.title')}</h3>
          <div className={classes.contentContainer}>
            <GridContainer alignItems="center" justify="center">
              <GridItem xs={12}>
                <WithPermission allowPermissions={[]}>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: '10px',
                    }}
                  >
                    <Formik
                      ref={ref => {
                        this.formikRef = ref;
                      }}
                      initialValues={fields}
                      validationSchema={validationSchema}
                      onSubmit={values => this.handleSubmit(values)}
                      render={({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleSubmit,
                        handleBlur,
                      }) => (
                        <form onSubmit={handleSubmit}>
                          <div
                            className={classes.adFormContainer}
                            style={{
                              display: 'flex',
                              flexDirection: 'column',
                              alignItems: 'center',
                              gap: 16,
                            }}
                          >
                            <TextField
                              label={t('send_email.email')}
                              name="email"
                              error={touched.email && !!errors.email}
                              helperText={touched.email ? errors.email : ''}
                              InputProps={{
                                value: values.email,
                                onChange: e => handleChange(e),
                                onBlur: handleBlur,
                                type: 'email',
                              }}
                              fullWidth
                            />
                            <FormControl
                              fullWidth
                              className={classes.selectFormControl}
                              error={touched.template && !!errors.template}
                            >
                              <InputLabel
                                htmlFor="template"
                                className={classes.selectLabel}
                              >
                                {t('send_email.template')}
                              </InputLabel>
                              <Select
                                value={values.template}
                                onChange={e => handleChange(e)}
                                onBlur={handleBlur}
                                MenuProps={{ className: classes.selectMenu }}
                                classes={{
                                  select: classes.select,
                                }}
                                inputProps={{
                                  name: 'template',
                                  id: 'template',
                                }}
                              >
                                {EMAIL_TEMPLATES.map(template => (
                                  <MenuItem
                                    key={template}
                                    classes={{
                                      root: classes.selectMenuItem,
                                      selected: classes.selectMenuItemSelected,
                                    }}
                                    value={template}
                                  >
                                    {template}
                                  </MenuItem>
                                ))}
                              </Select>
                              {touched.template && errors.template && (
                                <FormHelperText>
                                  {errors.template}
                                </FormHelperText>
                              )}
                            </FormControl>
                            <TextField
                              label={t('send_email.context')}
                              name="context"
                              error={touched.context && !!errors.context}
                              helperText={touched.context ? errors.context : ''}
                              multiline
                              rows={15}
                              fullWidth
                              InputProps={{
                                value: values.context,
                                onChange: e => handleChange(e),
                                onBlur: handleBlur,
                                type: 'text',
                              }}
                            />
                            <Button
                              simple
                              context-test="cache-key"
                              color="primary"
                              disabled={
                                !values.context ||
                                !values.template ||
                                !values.email ||
                                Object.keys(errors).length > 0
                              }
                              onClick={() => sendEmail(values)}
                            >
                              {t('send_email.btn')}
                            </Button>
                          </div>
                        </form>
                      )}
                    />
                  </div>
                </WithPermission>
              </GridItem>
            </GridContainer>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

SendEmail.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  t: PropTypes.func.isRequired,
  sendEmail: PropTypes.func.isRequired,
  errors: PropTypes.instanceOf(Array).isRequired,
  success: PropTypes.bool.isRequired,
  closeNotification: PropTypes.func.isRequired,
};

export default withTranslation()(
  withStyles({
    ...extendedTablesStyle,
    ...sweetAlertStyle,
    ...customSelectStyle,
  })(SendEmail),
);
